import React from 'react';
import { css } from '@bts-web/utils-style-engine';
import { SVGIconType } from '../types';

const RegularInfo: React.FC<SVGIconType> = ({
  color,
  size = 22,
  width,
  height,
  className,
  ...restProps
}) => {
  const wrapperClassName = css({
    color: color || 'neutrals.text_primary',
    display: 'inline-flex',
    alignItems: 'center',
    justifyContent: 'center',
    width: width || size,
    height: height || size,
  });

  return (
    <span
      data-testid="icon_info"
      className={
        className ? `${wrapperClassName} ${className}` : wrapperClassName
      }
      data-element="icon"
      aria-label="info icon"
      {...restProps}
    >
      <svg
        viewBox="0 0 20 20"
        xmlns="http://www.w3.org/2000/svg"
        width={`${size}px`}
        height={`${size}px`}
        fill="currentcolor"
      >
        <path d="M10.0001 -0.00195312C15.5238 -0.00195312 20.0016 4.47589 20.0016 9.9996C20.0016 15.5233 15.5238 20.0011 10.0001 20.0011C4.47638 20.0011 -0.00146484 15.5233 -0.00146484 9.9996C-0.00146484 4.47589 4.47638 -0.00195312 10.0001 -0.00195312ZM10.0001 1.49805C5.30481 1.49805 1.49854 5.30432 1.49854 9.9996C1.49854 14.6949 5.30481 18.5011 10.0001 18.5011C14.6954 18.5011 18.5016 14.6949 18.5016 9.9996C18.5016 5.30432 14.6954 1.49805 10.0001 1.49805ZM9.99644 8.49863C10.3761 8.49838 10.6901 8.78033 10.74 9.14637L10.7469 9.24814L10.7505 14.7497C10.7508 15.1639 10.4152 15.5 10.001 15.5002C9.62133 15.5005 9.30735 15.2185 9.25745 14.8525L9.25053 14.7507L9.24693 9.24912C9.24666 8.83491 9.58223 8.4989 9.99644 8.49863ZM10.0005 5.00086C10.5521 5.00086 10.9992 5.44798 10.9992 5.99953C10.9992 6.55107 10.5521 6.99819 10.0005 6.99819C9.44899 6.99819 9.00187 6.55107 9.00187 5.99953C9.00187 5.44798 9.44899 5.00086 10.0005 5.00086Z" />
      </svg>
    </span>
  );
};

export { RegularInfo };
